<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 09:50:34
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-16 09:50:34
 -->
<template>
  <el-button type="primary" @click="loginClickHandler">没看错，我就是登陆按钮</el-button>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { pages } from '@/config'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
    }
  },
  computed: mapState([ 'loaded' ]),
  methods: {
    ...mapActions([
      'pageLogin',
    ]),
    loginClickHandler () {
      this.pageLogin({
        username: 'testgly',
        password: '792681',
      })
    },
  },
  mounted () {
    this.loaded && this.$router.push(pages.home.path)
  },
}
</script>
